<div class="photo-dialog">
  <div class="photo-container">
    <img [src]="customer.photoUrl" [alt]="customer.name" class="customer-photo" />
  </div>
  <div class="customer-info">
    <h3>{{customer.name}}</h3>
    <p *ngIf="customer.federalId">{{customer.federalId}}</p>
  </div>
</div>